import { INumberFormatter, NUMBER_FORMATTER_TOKEN } from '@cgs/common';
import { RESOURCES_COMPONENT_TOKEN, ResourcesComponent } from '@cgs/machines';
import { TRIFECTA_LAUNCH_PARAMS_TOKEN, TrifectaLaunchParamsDto } from '@cgs/provider-trifecta';
import { Action, Container, SceneObject, TextSceneObject } from '@cgs/wge';

export const CORSICA_WIN_LINE_POPUP_TOKEN = Symbol('CorsicaWinLinePopup');

const enum SceneNames {
  LowWin = 'lowWin',
  LowWinText = 'winTxt',
}

const enum States {
  Default = 'default',
  Show = 'show',
}

export class CorsicaWinLinePopup {
  private readonly lowWinScene: SceneObject;
  private readonly lowWinTextNode: TextSceneObject;
  private readonly currencyDecimals: number;
  private readonly currency: string;
  private readonly numberFormatter: INumberFormatter;

  constructor(container: Container) {
    const root = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN).slot;

    const lowWinScene = root.findById(SceneNames.LowWin);

    if (!lowWinScene) {
      throw new Error('Low win scene not found');
    }

    this.lowWinScene = lowWinScene;

    const lowWinTextNode = lowWinScene.findById<TextSceneObject>(SceneNames.LowWinText);

    if (!lowWinTextNode) {
      throw new Error('Low win text node not found');
    }
    this.lowWinTextNode = lowWinTextNode;

    const launchParams = container.resolve<TrifectaLaunchParamsDto>(TRIFECTA_LAUNCH_PARAMS_TOKEN);
    this.numberFormatter = container.resolve<INumberFormatter>(NUMBER_FORMATTER_TOKEN);

    this.currencyDecimals = launchParams.currencyDecimals;
    this.currency = launchParams.currencyId;
  }

  public show(win: number): Action {
    this.lowWinTextNode.text = `${this.currency} ${this.numberFormatter.format(win, this.currencyDecimals)}`;

    const enterAction = this.lowWinScene.stateMachine!.findById(States.Show)!.enterAction;

    this.lowWinScene.stateMachine!.switchToState(States.Default);
    this.lowWinScene.stateMachine!.switchToState(States.Show);
    return enterAction;
  }
}
